import { useSessionEnvironment } from "@hornet-web-react/core/contexts/session"
import { getEmberAppUrl } from "../utils/ember-app-url"

export function useEmberAppUrl() {
  const { currentAppUrl } = useSessionEnvironment()

  return getEmberAppUrl(currentAppUrl)
}
